import { render } from "./CentralLayout.vue?vue&type=template&id=a6fae016"
import script from "./CentralLayout.vue?vue&type=script&lang=js"
export * from "./CentralLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pulsell/data/www/driver.pulsell.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__